import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useRegenerateApiKey } from "../../hooks/use-service-accounts";

interface RegenerateKeyDialogProps {
  serviceAccountId: string;
  serviceAccountName: string;
  onApiKeyGenerated: (apiKey: string) => void;
}

export const RegenerateKeyDialog = ({
  serviceAccountId,
  serviceAccountName,
  onApiKeyGenerated,
}: RegenerateKeyDialogProps) => {
  const { regenerateApiKey, loading, error } = useRegenerateApiKey(serviceAccountId);

  const handleRegenerate = async () => {
    try {
      const result = await regenerateApiKey();
      if (result?.apiKey) {
        onApiKeyGenerated(result.apiKey);
      }
      toast.success("Clé API régénérée avec succès", { style: { color: "#228B22" } });
    } catch {
      toast.error(error?.message || "Une erreur s'est produite");
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="cursor-pointer bg-transparent border-none p-0"
          onClick={(e) => e.stopPropagation()}
          type="button"
        >
          Régénérer la clé
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Régénérer la clé API</AlertDialogTitle>
          <AlertDialogDescription>
            Êtes-vous sûr de vouloir régénérer la clé API du compte de service{" "}
            <span className="font-bold text-foreground">«&nbsp;{serviceAccountName}&nbsp;»</span> ? L'ancienne clé sera
            immédiatement invalidée.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          {loading ? (
            <Button variant="default" disabled>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Régénération...
            </Button>
          ) : (
            <AlertDialogAction onClick={handleRegenerate}>Régénérer</AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
